const baseUrl = process.env.NEXT_PUBLIC_LANGUAGE_LIST_URL;

// 发送表单
export const sendForm = async (data: any, captchaToken: string) => {
	const res = await fetch(`${baseUrl}/website/chart`, {
		method: "POST",
		body: JSON.stringify({ ...data, captcha_token: captchaToken }),
		headers: {
			"Content-Type": "application/json", // Specify that the request body is JSON
		},
	});
	return res.json();
};
